var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM10 18.75C5.17578 18.75 1.25 14.8242 1.25 10C1.25 5.17578 5.17578 1.25 10 1.25C14.8242 1.25 18.75 5.17578 18.75 10C18.75 14.8242 14.8242 18.75 10 18.75Z",
    fill: "#00D220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13918 10.8839L7.79059 13.5353C8.27762 14.0236 9.06996 14.0236 9.55824 13.5353L14.8611 8.2325C15.3493 7.74422 15.3493 6.95203 14.8611 6.46484C14.374 5.97656 13.5817 5.97656 13.0934 6.46484L8.67434 10.8839L6.90668 9.11641C6.4184 8.62813 5.62621 8.62813 5.13902 9.11641C4.6509 9.60469 4.6509 10.3969 5.13918 10.8839Z",
    fill: "#00D220"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_1739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskComplete);
export default __webpack_public_path__ + "static/media/task-complete.b672fde60b2069b09313138527d6fa4f.svg";
export { ForwardRef as ReactComponent };